import React from 'react';
import { Helmet } from 'react-helmet';
import { PageAbsolutePath } from '../../consts/Common';
import ReloadHandler from '../common/ReloadHandler';
import { useJourney } from './Layout';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../app-state/Hooks';

/**
 * `FailedRegistration` renders the payment/registration failure page for
 * dealer/customer journeys.
 *
 * It displays the failure reason from journey state, sets the document title,
 * and provides a `ReloadHandler` that returns the user to the landing page.
 */

const FailedRegistration = (): JSX.Element => {
  const { journey } = useJourney();
  const { registrationFailMsg } = journey;
  const { t } = useTranslation();

  const supportPhone =
    useAppSelector((s) => s.content.failedRegistration?.phone)?.trim() ||
    '0344 573 8002';

  return (
    <>
      <Helmet>
        <title>{t('page-title.registration-failure')}</title>
      </Helmet>

      <div>
        <h3>{t('confirmation.purchase-not-completed-message')}</h3>
        <p className='p2 m1-bottom'>{registrationFailMsg}</p>
        <p className='p2'>
          {t('confirmation.contact-us-message', { phone: supportPhone })}
        </p>
        <ReloadHandler reloadPath={PageAbsolutePath.Landing} />
      </div>
    </>
  );
};

export default FailedRegistration;
